import { MEPUris } from "src/constants/mep-uris";
import { Environment } from "src/libs/environment";
import { Platform } from "src/libs/platform";
import { Chat, ChatProviders } from "src/shared/services/chat/chat-service";
import { store } from "src/redux/store";
import { toggleChatDelayModal } from "src/redux/ui/actions";

export class CrmChat implements Chat {
    private isChatFeatureOn = Environment.bool("CHAT_FEATURE_ON");
    private chatProvider = Environment.string("CHAT_PROVIDER");
    private isChatDelayEnabled = Environment.bool("CHAT_DELAY_FEATURE_ON");

    show(skipDelayModal = false): Promise<void> {
        if (this.isChatDelayEnabled && !skipDelayModal) {
            store.dispatch(toggleChatDelayModal());
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            window.location.assign(MEPUris.URI_MEP_CHAT);
            resolve();
        });
    }

    hide(): Promise<void> {
        return Promise.resolve();
    }

    shouldShow(): boolean {
        return (
            this.isChatFeatureOn &&
            Platform.isRunningOnFlutter() &&
            this.chatProvider === ChatProviders.Crm
        );
    }
}
